<template>
  <div class="home">
    <div class="my-3 effect-list">
      <select class="form-select form-select-lg mb-3" aria-label="Large select example" @change="changeEffect">
        <option v-for="ef in effectList" :key="ef" :value="ef">{{ef}}</option>
      </select>
    </div>
    <div class="mb-5">
      <div
          class="effect-display-block"
          :style="{width:`${defaultWidth}px`,height:`${defaultHeight}px`}"
      >
        <div class="position-absolute">
          <Rain3D
              v-if="showEffect==='Rain3D' && themeType ==='Effect'"
              :sensorValue="sensorValueDetailComputed"
              :effect-theme="effectThemeComputed"
          />
          <WatchClock
              v-if="showEffect==='WatchClock' && themeType ==='Effect'"
              :effect-theme="effectThemeComputed"
          />
          <Snow
              v-if="showEffect==='Snow' && themeType ==='Effect'"
              :currentValue="currentTemperatureValue"
              :effect-theme="effectThemeComputed"
              :control-mode="route.meta.mode === 'controller'"
          />
          <Mandala
              v-if="showEffect==='Mandala' && themeType ==='Effect'"
              :currentValue="currentTemperatureValue"
              :effect-theme="effectThemeComputed"
          />
          <Kaleidoscope
              v-if="showEffect==='Kaleidoscope' && themeType ==='Effect'"
              :currentValue="currentTemperatureValue"
              :effect-theme="effectThemeComputed"
          />
          <RainbowShoot
              v-if="showEffect==='RainbowShoot' && themeType ==='Effect'"
              :currentValue="currentTemperatureValue"
              :effect-theme="effectThemeComputed"
          />
          <TimeTunnel
              v-if="showEffect==='TimeTunnel' && themeType ==='Effect'"
              :currentValue="currentTemperatureValue"
              :effect-theme="effectThemeComputed"
          />
          <TwistHole
              v-if="showEffect==='TwistHole' && themeType ==='Effect'"
              :currentValue="currentTemperatureValue"
              :effect-theme="effectThemeComputed"
          />
          <Blossom
              v-if="showEffect==='Blossom' && themeType ==='Effect'"
              :currentValue="currentTemperatureValue"
              :effect-theme="effectThemeComputed"
          />
          <FlyInWording
              v-if="showEffect==='FlyInWording' && themeType ==='Effect'"
              :effect-theme="effectThemeComputed"
              :control-mode="route.meta.mode === 'controller'"
          />
          <Fireworks
              v-if="showEffect==='Fireworks' && themeType ==='Effect'"
              :currentValue="currentTemperatureValue"
              :effect-theme="effectThemeComputed"
              :control-mode="route.meta.mode === 'controller'"
          />
          <MeteorShower
              v-if="showEffect==='MeteorShower' && themeType ==='Effect'"
              :currentValue="currentTemperatureValue"
              :effect-theme="effectThemeComputed"
              :control-mode="route.meta.mode === 'controller'"
          />
          <Swirl
              v-if="showEffect==='Swirl' && themeType ==='Effect'"
              :currentValue="currentTemperatureValue"
              :effect-theme="effectThemeComputed"
          />
          <TransformSpot
              v-if="showEffect==='TransformSpot' && themeType ==='Effect'"
              :currentValue="currentTemperatureValue"
              :effect-theme="effectThemeComputed"
          />
          <SnowWording
              v-if="showEffect==='SnowWording' && themeType ==='Effect'"
              :control-mode="route.meta.mode === 'controller'"
              :effect-theme="effectThemeComputed"
          />
          <Snow3d
              v-if="showEffect==='Snow3d' && themeType ==='Effect'"
              :control-mode="route.meta.mode === 'controller'"
              :effect-theme="effectThemeComputed"
          />
          <Color
              v-if="showEffect==='Color' && themeType ==='Color'"
              :currentValue="currentTemperatureValue"
              :effect-theme="effectThemeComputed"
          />
          <Image
              v-if="showEffect==='Image' && themeType ==='Image'"
              :currentValue="currentTemperatureValue"
              :effect-theme="effectThemeComputed"
              :control-mode="route.meta.mode === 'controller'"
          />
          <Robot
              v-if="showEffect==='Robot' && themeType ==='Effect'"
              :sensorValue="sensorValueDetailComputed"
          />
          <PlanetCity
              v-if="showEffect==='PlanetCity' && themeType ==='Effect'"
              :sensorValue="sensorValueDetailComputed"
          />
          <Steampunk
              v-if="showEffect==='Steampunk' && themeType ==='Effect'"
              :sensorValue="sensorValueDetailComputed"
          />
          <Atmosphere
              v-if="showEffect==='Atmosphere' && themeType ==='Effect'"
              :sensorValue="sensorValueDetailComputed"
          />
          <Radio
              v-if="showEffect==='Radio' && themeType ==='Effect'"
              :effect-theme="effectThemeComputed"
              :sensorValue="sensorValueDetailComputed"
          />

        </div>

        <!-- 文字模式 -->
        <TextSliderSensor
            v-if="textData.Type === 'SliderSensor'"
            :textData="textDataComputed"
            :sensorValue="sensorValueDetailComputed"
            :effect-mode="effectMode"
        />
        <TextDuoSensor
            v-if="textData.Type === 'DuoSensor'"
            :textData="textDataComputed"
            :sensorValue="sensorValueDetailComputed"
            :effect-mode="effectMode"
        />
        <TextThreeSensor
            v-if="textData.Type === 'ThreeSensor'"
            :textData="textDataComputed"
            :sensorValue="sensorValueDetailComputed"
            :effect-mode="effectMode"
        />
        <TextFourSensor
            v-if="textData.Type === 'FourSensor'"
            :textData="textDataComputed"
            :sensorValue="sensorValueDetailComputed"
            :effect-mode="effectMode"
        />
        <TextTime
            v-if="textData.Type === 'Time'"
            :textData="textDataComputed"
            :effect-mode="effectMode"
        />
        <TextCustom
            v-if="textData.Type === 'Custom'"
            :textData="textDataComputed"
            :effect-mode="effectMode"
            :control-mode="route.meta.mode === 'controller'"
        />
        <!--  浮水印模式 -->
        <WatermarkMode
            v-if="watermarkDataComputed.HasImage"
            :watermarkData="watermarkDataComputed"
        />



      </div>
    </div>
    <!-- controllerMode -->
    <div class="w-100 effect-control-panel container-fluid">
      <div class="row">
        <div class="col-6">
          <SensorController @getSensorsData="getSensorsData"/>
        </div>
        <div class="col-6">
          <WatchClockController
              v-if="showEffect==='WatchClock' && themeType ==='Effect'"
              :effectName="showEffect"
              @getTempControlData="getTempControlData"
          />
          <Rain3DController
              v-if="showEffect==='Rain3D' && themeType ==='Effect'"
              :effectName="showEffect"
              @getTempControlData="getTempControlData"
          />
          <SnowController
              v-if="showEffect==='Snow' && themeType ==='Effect'"
              :effectName="showEffect"
              @getTempControlData="getTempControlData"
          />
          <MandalaController
              v-if="showEffect==='Mandala' && themeType ==='Effect'"
              :effectName="showEffect"
              @getTempControlData="getTempControlData"
          />
          <TimeTunnelController
              v-if="showEffect==='TimeTunnel' && themeType ==='Effect'"
              :effectName="showEffect"
              @getTempControlData="getTempControlData"
          />
          <TwistHoleController
              v-if="showEffect==='TwistHole' && themeType ==='Effect'"
              :effectName="showEffect"
              @getTempControlData="getTempControlData"
          />
          <BlossomController
              v-if="showEffect==='Blossom' && themeType ==='Effect'"
              :effectName="showEffect"
              @getTempControlData="getTempControlData"
          />
          <FlyInWordingController
              v-if="showEffect==='FlyInWording' && themeType ==='Effect'"
              :effectName="showEffect"
              @getTempControlData="getTempControlData"
          />
          <MeteorShowerController
              v-if="showEffect==='MeteorShower' && themeType ==='Effect'"
              :effectName="showEffect"
              @getTempControlData="getTempControlData"
          />
          <KaleidoscopeController
              v-if="showEffect==='Kaleidoscope' && themeType ==='Effect'"
              :effectName="showEffect"
              @getTempControlData="getTempControlData"
          />
          <RainbowShootController
              v-if="showEffect==='RainbowShoot' && themeType ==='Effect'"
              :effectName="showEffect"
              @getTempControlData="getTempControlData"
          />
          <FireworksController
              v-if="showEffect==='Fireworks' && themeType ==='Effect'"
              :effectName="showEffect"
              @getTempControlData="getTempControlData"
          />
          <SwirlController
              v-if="showEffect==='Swirl' && themeType ==='Effect'"
              :effectName="showEffect"
              @getTempControlData="getTempControlData"
          />
          <TransformSpotController
              v-if="showEffect==='TransformSpot' && themeType ==='Effect'"
              :effectName="showEffect"
              @getTempControlData="getTempControlData"
          />
          <SnowWordingController
              v-if="showEffect==='SnowWording' && themeType ==='Effect'"
              :effectName="showEffect"
              @getTempControlData="getTempControlData"
          />
          <Snow3dController
              v-if="showEffect==='Snow3d' && themeType ==='Effect'"
              :effectName="showEffect"
              @getTempControlData="getTempControlData"
          />
          <RadioController
              v-if="showEffect==='Radio' && themeType ==='Effect'"
              :effectName="showEffect"
              @getTempControlData="getTempControlData"
          />
          <ImageController
              v-if="showEffect==='Image' && themeType ==='Image'"
              :type-name="showEffect"
              @getTempControlData="getTempControlData"
          />
          <ColorController
              v-if="showEffect==='Color' && themeType ==='Color'"
              :type-name="showEffect"
              @getTempControlData="getTempControlData"
          />

        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import {ref, reactive, onMounted, computed, watchEffect} from "vue"
import defaultValue from "@/utils/defaultValue"
import {useRoute} from "vue-router";

// AnimateMode
import Mandala from '@/components/AnimateMode/MandalaShowMode.vue'
import Blossom from '@/components/AnimateMode/BlossomShowMode.vue'
import TimeTunnel from "@/components/AnimateMode/TimeTunnelShowMode.vue"
import Snow from '@/components/AnimateMode/SnowShowMode.vue'
import TwistHole from "@/components/AnimateMode/TwistHoleShowMode.vue"
import Image from "@/components/AnimateMode/ImgaeShowMode.vue"
import Color from "@/components/AnimateMode/ColorShowMode.vue"
import WatermarkMode from "@/components/AnimateMode/WatermarkShowMode.vue"
import Rain3D from "@/components/AnimateMode/Rain3DShowMode.vue";
import WatchClock from "@/components/AnimateMode/WatchClockShowMode.vue";
import FlyInWording from "@/components/AnimateMode/FlyInWordingShowMode.vue";
import Fireworks from "@/components/AnimateMode/FireworksShowMode.vue";
import MeteorShower from "@/components/AnimateMode/MeteorShowerShowMode.vue";
import Kaleidoscope from "@/components/AnimateMode/KaleidoscopeShowMode.vue";
import RainbowShoot from "@/components/AnimateMode/RainbowShootShowMode.vue";
import Swirl from "@/components/AnimateMode/SwirlShowMode.vue";
import TransformSpot from "@/components/AnimateMode/TransformSpotShowMode.vue";
import SnowWording from "@/components/AnimateMode/SnowWordingShowMode.vue";
import Snow3d from "@/components/AnimateMode/Snow3dShowMode.vue";

import TextSliderSensor from "@/components/AnimateMode/TextSliderSensorShowMode.vue";
import TextTime from "@/components/AnimateMode/TextTimeShowMode.vue";
import TextDuoSensor from "@/components/AnimateMode/TextDuoSensorShowMode.vue";
import TextThreeSensor from "@/components/AnimateMode/TextThreeSensorShowMode.vue";
import TextFourSensor from "@/components/AnimateMode/TextFourSensorShowMode.vue";
import TextCustom from "@/components/AnimateMode/TextCustomShowMode.vue";

import Robot from "@/components/AnimateMode/RobotShowMode.vue";
import PlanetCity from "@/components/AnimateMode/PlanetCityShowMode.vue";
import Steampunk from "@/components/AnimateMode/SteampunkShowMode.vue";
import Atmosphere from "@/components/AnimateMode/AtmosphereShowMode.vue";
import Radio from "@/components/AnimateMode/RadioShowMode.vue";

// controllerMode
import SensorController from "@/components/controllerMode/SensorController.vue"
import MandalaController from "@/components/controllerMode/MandalaController.vue"
import TimeTunnelController from "@/components/controllerMode/TimeTunnelController.vue"
import TwistHoleController from "@/components/controllerMode/TwistHoleController.vue"
import BlossomController from "@/components/controllerMode/BlossomController.vue"
import SnowController from "@/components/controllerMode/SnowController.vue"
import ImageController from "@/components/controllerMode/ImageController.vue"
import ColorController from "@/components/controllerMode/ColorController.vue"
import Rain3DController from "@/components/controllerMode/Rain3DController.vue";
import WatchClockController from "@/components/controllerMode/WatchClockController.vue";
import FlyInWordingController from "@/components/controllerMode/FlyInWordingController.vue";
import FireworksController from "@/components/controllerMode/FireworksController.vue";
import MeteorShowerController from "@/components/controllerMode/MeteorShowerController.vue";
import KaleidoscopeController from "@/components/controllerMode/KaleidoscopeController.vue";
import RainbowShootController from "@/components/controllerMode/RainbowShootController.vue";
import SwirlController from "@/components/controllerMode/SwirlController.vue";
import TransformSpotController from "@/components/controllerMode/TransformSpotController.vue";
import SnowWordingController from "@/components/controllerMode/SnowWordingController.vue";
import Snow3dController from "@/components/controllerMode/Snow3dController.vue";
import RadioController from "@/components/controllerMode/RadioController.vue";


const route = useRoute()
const {defaultWidth, defaultHeight} = defaultValue()

const defaultSensor = JSON.stringify(require('@/json/DefaultSensor.json'))
const showEffect = ref('') //要顯示哪個特效
const themeType = ref('') // 特效背景主題||純圖片影片背景主題||純色背景主題
const effectMode = ref('') // 特效Name
const textData = reactive({}) // 純文字背景主題資料
const textDataComputed = computed(() => {
  return textData
}) // 純文字背景主題資料
const watermarkData = reactive({}) // 浮水印資料
const watermarkDataComputed = computed(() => {
  return watermarkData
}) // 浮水印資料
const sensorValue = reactive({detail: {}}) // 取得sensor資料
const sensorValueDetailComputed = computed(() => {
  return sensorValue.detail
})
const configValue = reactive({}) // 取得config資料
const effectList = reactive([
  // 'Rain',
  'Snow',
  'Mandala',
  'Blossom',
  'TimeTunnel',
  // 'Snow Wording',
  'TwistHole',
  'Rain3D',
  'WatchClock',
  'Image',
  'Color',
  'FlyInWording',
  'Fireworks',
  'MeteorShower',
    'Kaleidoscope',
    'RainbowShoot',
    'Swirl',
    'TransformSpot',
    'SnowWording',
    'Snow3d',
    'Robot',
    'PlanetCity',
    'Steampunk',
    'Atmosphere',
    'Radio'
])
const currentTemperatureValue = ref(null) // 參考sensor的Value

const jsonMap = {
  Mandala: JSON.stringify(require('@/json/Mandala.json')),
  TimeTunnel: JSON.stringify(require('@/json/TimeTunnel.json')),
  TwistHole: JSON.stringify(require('@/json/TwistHole.json')),
  Blossom: JSON.stringify(require('@/json/Blossom.json')),
  Snow: JSON.stringify(require('@/json/Snow.json')),
  Rain3D: JSON.stringify(require('@/json/Rain3D.json')),
  WatchClock: JSON.stringify(require('@/json/WatchClock.json')),
  Image: JSON.stringify(require('@/json/Image.json')),
  Color: JSON.stringify(require('@/json/Color.json')),
  FlyInWording: JSON.stringify(require('@/json/FlyInWording.json')),
  Fireworks: JSON.stringify(require('@/json/Fireworks.json')),
  MeteorShower: JSON.stringify(require('@/json/MeteorShower.json')),
  Kaleidoscope: JSON.stringify(require('@/json/Kaleidoscope.json')),
  RainbowShoot: JSON.stringify(require('@/json/RainbowShoot.json')),
  Swirl: JSON.stringify(require('@/json/Swirl.json')),
  TransformSpot: JSON.stringify(require('@/json/TransformSpot.json')),
  SnowWording: JSON.stringify(require('@/json/SnowWording.json')),
  Snow3d: JSON.stringify(require('@/json/Snow3d.json')),
  Robot: JSON.stringify(require('@/json/Robot.json')),
  PlanetCity: JSON.stringify(require('@/json/PlanetCity.json')),
  Steampunk: JSON.stringify(require('@/json/Steampunk.json')),
  Atmosphere: JSON.stringify(require('@/json/Atmosphere.json')),
  Radio: JSON.stringify(require('@/json/Radio.json')),
}

///////////整理中////////
const effectTheme = reactive({}) // 特效主題的資料
const effectThemeComputed = computed(() => {
  return effectTheme
    }) // 特效主題的資料

const changeEffect = ($el) =>{
  const ef = $el.target.value
  // 切換動畫
  // showEffect
  showEffect.value = ef
  // configValue
  const currentConfig = JSON.parse(jsonMap[ef])
  // processConfig
  configValue.value = processConfigByJsonFile(currentConfig)
  const {
      Theme, // 主題模式 obj
      Text, // 文字模式
      Watermark // 浮水印
  } = configValue.value
  themeType.value = Theme.Type
  effectMode.value = Theme.Effect ? Theme.Effect : 'none'
  // 取得 主題模式 obj
  Object.assign(effectTheme , Theme)
  processThemeDetail(themeType.value, Theme, Text)
  // 取得 文字模式
  initTextData()
  if (Text) Object.assign(textData , Text)
  // 取得浮水印
  initWatermark()
  if (Watermark) Object.assign(watermarkData , Watermark)
  // sensorValue
  const {Sensor, IsDynamicMode} = Theme
  if (themeType.value === 'Effect' && IsDynamicMode) {
    currentTemperatureValue.value = processDynamicValueByJsonFile(Sensor, sensorValue.detail)
  }
}

function processConfigByJsonFile (item){
  const {Screens} = item
  const {Text, Theme, Watermark} = Screens[0]
  return {
    Theme, // 主題模式 ()
    Text, // 文字模式
    Watermark // 浮水印
  }
}

function processThemeDetail (type, theme, texts){
  let RingColor = [0,0,0]
  if (texts) {
    const {Layout} = texts
    if (Layout ) RingColor = Layout[0].FontColors[1]
  }
  switch (type) {
    case 'Image':
      showEffect.value = 'Image'
      themeType.value = 'Image'
      effectMode.value = 'Image'
      return false
    case 'Color':
      showEffect.value = 'Color'
      themeType.value = 'Color'
      effectMode.value = 'Color'
      return false
    case 'Effect':
      showEffect.value = theme.Effect
      themeType.value = type
      // 取得 RingColor (Blossom use)
      if (showEffect.value === 'Blossom') Object.assign(effectTheme , theme, {RingColor})
      return false
    default:
      return false
  }
}

function getTempControlData (item) {
  const {
    Theme, // 主題模式 obj
    Text, // 文字模式
    Watermark // 浮水印
  } = item
  // 取得 主題模式 obj
  Object.assign(effectTheme, Theme)

  processThemeDetail(themeType.value, Theme, Text)
  // 取得 文字模式
  initTextData()
  if (Text) Object.assign(textData , Text)
  // 取得浮水印
  initWatermark()
  if (Watermark) Object.assign(watermarkData , Watermark)
}

function getSensorsData (jsonStr) {
  Object.assign(sensorValue.detail , JSON.parse(jsonStr))
  // sensorValue
  const {Sensor, IsDynamicMode, Type} = effectTheme
  if (Type === 'Effect' && IsDynamicMode) currentTemperatureValue.value = processDynamicValueByJsonFile(Sensor, sensorValue.detail)
}

// processDynamicValueByJsonFile
// 取得硬體資訊(sensor), only dynamicMode
const processDynamicValueByJsonFile = (sensor,obj) =>{
  return obj[sensor].Value
}

const initTextData = () => {
  Object.assign(textData, {
    Type: "None"
  })
}

const initWatermark = () => {
  Object.assign(watermarkData, {
    HasImage: false,
    Image: "",
    Opacity: 100
  })
}

// 取得 sensor by browser
document.addEventListener('sensorChanged', (e) => {
  Object.assign(sensorValue.detail , e.detail)
  // sensorValue
  const {Sensor, IsDynamicMode, Type} = effectTheme
  if (Type === 'Effect' && IsDynamicMode) currentTemperatureValue.value = processDynamicValueByJsonFile(Sensor, sensorValue.detail)
});

// 取得 config by browser
document.addEventListener('configChanged', (e) => {
  if(!sensorValue.detail['CPULoad']) {
    const sensorDataParse = {detail: JSON.parse(defaultSensor)}
    Object.assign(sensorValue.detail , sensorDataParse.detail)
  }

  let screensData = e.detail
  // processConfig
  configValue.value = processConfigByJsonFile(screensData)
  const {
    Theme, // 主題模式 obj
    Text, // 文字模式
    Watermark // 浮水印
  } = configValue.value
  themeType.value = Theme.Type
  effectMode.value = Theme.Effect ? Theme.Effect : 'none'
  // 取得 主題模式 obj
  Object.assign(effectTheme , Theme)
  processThemeDetail(themeType.value, Theme, Text)
  showEffect.value = Theme.Effect
  // 取得 文字模式
  initTextData()
  if (Text) Object.assign(textData , Text)
  // 取得浮水印
  initWatermark()
  if (Watermark && Text !== Watermark) Object.assign(watermarkData , Watermark)
  // sensorValue
  const {Sensor, IsDynamicMode} = Theme
  if (themeType.value === 'Effect' && IsDynamicMode) currentTemperatureValue.value = processDynamicValueByJsonFile(Sensor, sensorValue.detail)
})

onMounted(() => {
  const sensorDataParse = {detail: JSON.parse(defaultSensor)}
  Object.assign(sensorValue.detail , sensorDataParse.detail)

  // debug
  // setInterval(function () {
  //   Object.assign(sensorValue.detail , {
  //         "CPULoad": {
  //           "Type": "CPU",
  //           "Value": Math.floor(Math.random() * 100)+ 30,
  //           // "Value": 80,
  //           "Label": "LOAD",
  //           "Unit": "%"
  //         },
  //         "CPUTemperature": {
  //           "Type": "CPU",
  //           "Value": Math.floor(Math.random() * (60 - 45) + 45),
  //           "Label": "TEMP",
  //           "Unit": "°C"
  //         },
  //         "GPULoad": {
  //           "Type": "GPU",
  //           "Value": Math.floor(Math.random() * 100),
  //           "Label": "LOAD",
  //           "Unit": "%"
  //         },
  //         "GPUTemperature": {
  //           "Type": "GPU",
  //           "Value": Math.floor(Math.random() * 100),
  //           "Label": "TEMP",
  //           "Unit": "°C"
  //         },
  //         "PumpRPM": {
  //           "Type": "PUMP",
  //           "Value": Math.floor(Math.random() * 1000),
  //           "Label": "RPM",
  //           "Unit": "RPM"
  //         },
  //         "CoolantTemp": {
  //           "Type": "Coolant Temp",
  //           "Value": Math.floor(Math.random() * 100),
  //           "Label": "TEMP",
  //           "Unit": "°C"
  //         }
  //       }
  //   )
  // }, 1000)
})

watchEffect(() => {
  window.setSensorValue(`${JSON.stringify(sensorValue.detail)}`)
});
</script>
<style lang="scss">
@import "~@/assets/scss/HomeView.scss";
</style>
